@if (campanha(); as campanhaAtual) {
  <div class="campanhas-page campanha-detalhe-page">
    <header class="campanha-detalhe-header">
      <div class="campanha-detalhe-title-block">
        <app-back-button routerLink="/campanhas" label="Voltar para campanhas" data-testid="voltar-campanhas" />
        <div class="campanha-detalhe-title-row">
          <h1 class="page-main-title">{{ campanhaAtual.nome }}</h1>
          <app-status-badge [status]="campanhaAtual.status" [label]="campanhaAtual.statusLabel" />
        </div>
        <p class="campanha-detalhe-periodo" data-testid="campanha-periodo">
          Período da Campanha: {{ periodoLabel() }}
        </p>
      </div>

      <div class="page-toolbar detalhe-toolbar" role="toolbar" aria-label="Ações da campanha">
        @if (podeVisualizar()) {
          <button
            type="button"
            class="btn-primary btn-toolbar"
            data-testid="btn-visualizar-campanha"
            (click)="onVisualizarCampanha()"
          >
            Visualizar campanha
          </button>
        }
        @if (podeEditar()) {
          <button
            type="button"
            class="btn-secondary btn-toolbar"
            data-testid="btn-editar-campanha"
            (click)="onEditarCampanha()"
          >
            Editar campanha
          </button>
        }
        <button
          type="button"
          class="btn-primary btn-toolbar"
          data-testid="btn-exportar"
          [disabled]="exportando()"
          (click)="onExportar()"
        >
          {{ exportando() ? 'Exportando...' : 'Exportar' }}
        </button>
       
      </div>
    </header>

    
    <section class="indicadores-grid" aria-label="Indicadores da campanha">
      <app-indicador-card label="Adesões no portal" [value]="adesoesConcluidas().toString()" />
      <app-indicador-card label="Adesões" [value]="adesoesTotalLabel()" />
      <!-- comentado pois será aguardado o endpoint conforme conversado com a PO - 18/09/2026 -->
      <!-- <app-indicador-card
        label="Taxa de conversão"
        [value]="conversaoLabel()"
        [trend]="campanhaAtual.conversaoTendencia"
      /> -->
      <app-indicador-card label="Pendentes" [value]="adesoesPendentes().toString()" />
    </section>

    <section class="status-pie-chart-section" aria-labelledby="status-pie-chart-title">
      <h2 id="status-pie-chart-title" class="page-section-title">Adesões por status</h2>
      <app-status-pie-chart [segments]="adesoesPorStatus()" />
    </section>

    <app-adesao-filter-bar
      [periodoDe]="campanhaAtual.dataInicio"
      [periodoAte]="campanhaAtual.dataFim"
      (filtersChange)="onAdesaoFiltersChange($event)"
    />

    <section aria-labelledby="adesoes-section-title">
      <h2 id="adesoes-section-title" class="page-section-title">Adesões</h2>

      @if (adesoes().length === 0) {
        <app-empty-state message="Nenhuma adesão encontrada" />
      } @else {
        <app-data-table ariaLabel="Adesões da campanha">
          <thead>
            <tr>
              <th scope="col">Participante</th>
              <th scope="col">Matrícula</th>
              <th scope="col">Registro</th>
              <th scope="col">Plano</th>
              <th scope="col">Última atualização</th>
              <th scope="col">Status</th>
              <th scope="col"><span class="visually-hidden">Ações</span></th>
            </tr>
          </thead>
          <tbody>
            @for (adesao of adesoesPaginadas(); track adesao.id) {
              <tr>
                <td>
                  <span class="adesao-nome" data-testid="adesao-nome">{{ adesao.nome }}</span>
                </td>
                <td data-testid="adesao-matricula">{{ adesao.matricula ?? '—' }}</td>
                <td data-testid="adesao-registro">{{ adesao.registro ?? '—' }}</td>
                <td data-testid="adesao-plano">{{ adesao.nomePlano || '—' }}</td>
                <td data-testid="adesao-data-assinatura">
                  {{ adesao.dataAssinaturaTermo ? formatDate(adesao.dataAssinaturaTermo) : '-' }}
                </td>
                <td>
                  <app-status-badge [status]="adesao.status" />
                </td>
                <td class="actions-cell">
                  <div class="actions-menu" [class.actions-menu--open]="menuAbertoId() === adesao.id">
                    <button
                      type="button"
                      class="actions-menu-btn"
                      [attr.aria-expanded]="menuAbertoId() === adesao.id"
                      aria-haspopup="true"
                      [attr.aria-label]="'Ações para ' + adesao.nome"
                      data-testid="adesao-actions-menu-btn"
                      (click)="toggleMenu(adesao.id, $event)"
                    >
                      &#8942;
                    </button>
                    @if (menuAbertoId() === adesao.id) {
                      <div
                        class="actions-menu-dropdown actions-menu-dropdown--fixed"
                        role="menu"
                        [style.top.px]="menuPosition()?.top"
                        [style.right.px]="menuPosition()?.right"
                      >
                        <button
                          type="button"
                          role="menuitem"
                          data-testid="action-visualizar-protocolo"
                          (click)="onVisualizarProtocolo(adesao, $event)"
                        >
                          Visualizar Protocolo
                        </button>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </app-data-table>

        <app-pagination
          [currentPage]="currentPage()"
          [pageSize]="pageSize"
          [totalItems]="adesoes().length"
          (pageChange)="onPageChange($event)"
        />
      }
    </section>
  </div>

  @if (protocoloSelecionado(); as adesaoSelecionada) {
    <app-protocolo-log-dialog [adesao]="adesaoSelecionada" (close)="onFecharProtocolo()" />
  }
}
